import { client } from '@api/client';
import { URL } from '@api/urls';

import {
	IAlarmAcknowledgedByStaticDTO,
	IAlarmClearedByStaticDTO,
	IAlarmMiddlewareDTO,
} from '@interfaces/alarms/dto/alarmsDTO';
import { IVendor, TIdName, TNameTitle } from '@interfaces/common/common';

const {
	alarmManagementStaticOran,
	alarmManagementOranRoles,
	alarmManagementStaticOranMiddlewares,
	alarmManagementStaticOranNetworkElements,
	alarmManagementStaticOranClearedBy,
	alarmManagementStaticOranAcknowledgedBy,
	alarmAwtgRanStaticAlarmIds,
	alarmActiveOranGroups,
	alarmActiveOranModuleNames,
	alarmActiveOranSeverities,
	alarmActiveOranAlarmIds,
	alarmActiveOranApplicabilities,
	alarmActiveOranMiddlewares,
	alarmActiveOranNetworkElements,
	alarmActiveOranAcknowledgedBy,
} = URL;

export const getAlarmOranAlarmIds = (): Promise<Array<TNameTitle>> => {
	return client.get(alarmAwtgRanStaticAlarmIds);
};

export const getAlarmOranApplicabilities = (): Promise<Array<TNameTitle>> => {
	return client.get(`${alarmManagementStaticOran}/applicabilities`);
};

export const getAlarmOranGroups = (): Promise<Array<TNameTitle>> => {
	return client.get(`${alarmManagementStaticOran}/groups`);
};

export const getAlarmOranModuleNames = (): Promise<Array<TNameTitle>> => {
	return client.get(`${alarmManagementStaticOran}/module-names`);
};

export const getAlarmOranSeverities = (): Promise<Array<TNameTitle>> => {
	return client.get(`${alarmManagementStaticOran}/severities`);
};

export const getAlarmOranStatuses = (): Promise<Array<TNameTitle>> => {
	return client.get(`${alarmManagementStaticOran}/statuses`);
};

export const getAlarmOranEnableStatuses = (): Promise<Array<TNameTitle>> => {
	return client.get(`${alarmManagementStaticOran}/enable-statuses`);
};

export const getOranUserGroupsForAlarms = (): Promise<Array<TNameTitle>> => {
	return client.get(alarmManagementOranRoles);
};

export const getOranMiddlewaresForAlarms = (): Promise<Array<IAlarmMiddlewareDTO>> => {
	return client.get(alarmManagementStaticOranMiddlewares);
};

export const getOranNetworkElementsForAlarms = (): Promise<Array<TIdName>> => {
	return client.get(alarmManagementStaticOranNetworkElements);
};

export const getOranClearedBy = (): Promise<Array<IAlarmClearedByStaticDTO>> => {
	return client.get(alarmManagementStaticOranClearedBy);
};

export const getOranAcknowledgedBy = (): Promise<Array<IAlarmAcknowledgedByStaticDTO>> => {
	return client.get(alarmManagementStaticOranAcknowledgedBy);
};

export const getAlarmOranGroupsActive = (params?: IVendor): Promise<Array<TNameTitle>> => {
	return client.get(alarmActiveOranGroups, { params });
};

export const getAlarmOranModuleNamesActive = (params?: IVendor): Promise<Array<TNameTitle>> => {
	return client.get(alarmActiveOranModuleNames, { params });
};

export const getAlarmOranSeveritiesActive = (params?: IVendor): Promise<Array<TNameTitle>> => {
	return client.get(alarmActiveOranSeverities, { params });
};

export const getAlarmOranAlarmIdsActive = (params?: IVendor): Promise<Array<TNameTitle>> => {
	return client.get(alarmActiveOranAlarmIds, { params });
};

export const getAlarmOranApplicabilitiesActive = (params?: IVendor): Promise<Array<TNameTitle>> => {
	return client.get(alarmActiveOranApplicabilities, { params });
};

export const getOranMiddlewaresForAlarmsActive = (params?: IVendor): Promise<Array<IAlarmMiddlewareDTO>> => {
	return client.get(alarmActiveOranMiddlewares, { params });
};

export const getOranNetworkElementsForAlarmsActive = (params?: IVendor): Promise<Array<TIdName>> => {
	return client.get(alarmActiveOranNetworkElements, { params });
};

export const getOranAcknowledgedByForAlarmsActive = (
	params?: IVendor,
): Promise<Array<IAlarmAcknowledgedByStaticDTO>> => {
	return client.get(alarmActiveOranAcknowledgedBy, { params });
};
